<template>
  <div class="enterprise-list-page enterprise-list-page--inventory enterprise-list-page--medicine-order">
    <!-- Header Card -->
        <PageHeader icon="fas fa-prescription">
      <template #title>
        Order Pengambilan Obat {{ clinic_name }}
      </template>
      <template #subtitle>
        Tinjau daftar permintaan resep pengambilan obat, alkes, dan racikan obat pasien
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <modern-filter-bar
              embedded
              single-line
              :show-timeseries="false"
              :search-text.sync="filter.name"
              search-placeholder="Cari obat"
              @search-keyup="filterByName"
            >
              <!-- <div class="col-md-3">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text squared>
                      <b-icon-search></b-icon-search>
                    </b-input-group-text>
                  </template>
                  <b-form-input
                    type="text"
                    v-model="filter.batch"
                    placeholder="Cari Berdasar Batch"
                    @keyup="filterByName"
                  ></b-form-input>
                </b-input-group>
              </div> -->
              <template #additional-filters>
                <div class="modern-filter-select">
                  <b-form-select
                    v-model="filter.status"
                    :options="options"
                    @input="filterByStatus"></b-form-select>
                </div>
              </template>
            </modern-filter-bar>

            <!-- Table -->
            <medhop-data-table
              summary-title="Order Pengambilan Obat"
              striped
              hover
              class="mt-3"
              :items="items"
              :fields="fields"
              :style="'white-space: nowrap'"
              responsive="md">
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '15%' : '' }" />
              </template>
              <template #cell(stock_in_out)="data">
                <i
                  v-if="data.item.stock_in_out == 0"
                  class="fas fa-arrow-down"
                  style="color: green"
                  v-b-tooltip.hover
                  title="Stok Masuk"></i>
                <i
                  v-if="data.item.stock_in_out == 1"
                  class="fas fa-arrow-up"
                  style="color: red"
                  v-b-tooltip.hover
                  title="Stok Keluar"></i>
              </template>
              <template #cell(batch)="data">
                <!-- {{ displayAnesthetist(data.item.anesthetist_display) }} -->
                <ul v-for="batch in data.item.batch_display" :key="batch.id">
                  <li class="ml-5">
                    {{
                      batch.batch_no +
                      ":" +
                      batch.quantity +
                      " " +
                      `exp:(${batch.expired})`
                    }}
                  </li>
                </ul>
                <!-- <span v-if="data.item.anesthetist_display.length < 1">-</span> -->
              </template>
              <template #cell(status)="data">
                {{ data.item.status ? "Sudah diambil" : "Belum diambil" }}
              </template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  v-b-tooltip.hover
                  v-if="data.item.status == 1"
                  title="Sudah di ambil"
                  @click="setUse(data.item.id)"
                  class="mr-1 btn-success"><i class="fas fa-check px-0"></i></b-button>
                <b-button
                  size="sm"
                  v-b-tooltip.hover
                  v-if="data.item.status == 0"
                  title="Ambil"
                  variant="danger"
                  @click="setUse(data.item.id)"><i class="fas fa-check px-0"></i></b-button>
              </template>
            </medhop-data-table>
            <medhop-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"></medhop-pagination>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js";
import api from "@/core/services/api.service.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "List",

  components: {
    Card,
  },

  data() {
    return {
      // Filter
      filter: {
        name: "",
        batch: "",
        status: "",
      },
      options: [
        { value: "", text: "Cari Berdasar Status", disabled: true },
        { value: 0, text: "Sudah diambil" },
        { value: 1, text: "Belum diambil" },
      ],
      // Pagination
      perPage: 20,
      currentPage: 1,
      lastCurrentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "created_at_display",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "medicine_name",
          label: "Obat/Alkes",
          sortable: true,
        },
        {
          key: "stock_in_out",
          label: "Jenis Stok",
          sortable: true,
        },
        {
          key: "quantity",
          label: "Jumlah",
          sortable: true,
        },
        {
          key: "batch",
          label: "Batch",
          sortable: true,
        },
        {
          key: "source",
          label: "Permintaan dari",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // user access
      btn: false,
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    };
  },

  methods: {
    pageOnClick(page) {
      this.currentPage = page;
      this.lastCurrentPage = page;
      this.pagination();
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}&batch_no=${this.filter.batch}`;
      let response = await module.paginate(
        "medicine-stock-orders",
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;

      let a, b;
      b = this.perPage * (this.currentPage - 1) + 1;
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a;
      }

      this.items = response.data;
    },

    async setUse(id) {
      api.setHeader();
      let result = await api.put("medicine-stock-orders/set-use/" + id);
      if (result) {
        this.pagination();
      }
    },

    filterByName() {
      debouncer(() => {
        this.currentPage = 1;
        this.pagination();
      }, 500)
    },

    async filterByStatus(evt) {
      if (!evt) {
        this.filter.status = await "";
      } else {
        this.filter.status = await evt;
      }

      this.currentPage = 1;
      this.pagination();
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete("medicine-stock-orders/" + id);
      // If Deleted
      if (result) {
        this.pagination();
      }
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        // 

        if (access_right[a] == "9005") {
          this.btn = true;
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Order Pengambilan Obat" }]);
    // Get Data
    this.pagination();
    this.setActiveMenu();
  },
};
</script>
